import React from 'react';

const LargeCautionIcon = () => {
  return (
    <svg
      width='87'
      height='87'
      viewBox='0 0 87 87'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M36.3692 15.2998C39.4484 9.96648 47.1464 9.96647 50.2256 15.2998L82.5572 71.2998C85.6364 76.6331 81.7874 83.2998 75.629 83.2998H10.9658C4.80739 83.2998 0.958377 76.6331 4.03758 71.2998L36.3692 15.2998Z'
        fill='#E7EFFD'
      />
      <path
        d='M43.1056 65.0708C41.9384 65.0708 40.9922 64.1246 40.9922 62.9574C40.9922 61.7901 41.9384 60.8439 43.1056 60.8439H43.4881C44.6553 60.8439 45.6016 61.7901 45.6016 62.9574C45.6016 64.1246 44.6553 65.0708 43.4881 65.0708H43.1056ZM43.2969 58.1854C42.024 58.1854 40.9922 57.1536 40.9922 55.8807V39.834C40.9922 38.5611 42.024 37.5293 43.2969 37.5293C44.5697 37.5293 45.6016 38.5611 45.6016 39.834V55.8807C45.6016 57.1536 44.5697 58.1854 43.2969 58.1854Z'
        fill='#5B91F5'
      />
    </svg>
  );
};

export default LargeCautionIcon;
